import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CircularProgress from '@mui/material/CircularProgress'
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material'
import './AdminCalendar.css'
import DailyAvailability from './DailyAvailability'
import { convertToFormattedString } from '../../../utils/calendarFunctions'
import { getAvailablePathologist } from '../../../actions'
import { RootState } from '../../../reducers'
import { Typography, Box } from '@mui/material'
import {
  parseISO,
  previousSunday,
  isSunday,
  isSaturday,
  nextSaturday,
  nextSunday,
  previousSaturday,
  format,
} from 'date-fns'

const WeeklyCalendar = ({ startdate, enddate, handleChange }) => {
  const dispatch = useDispatch()
  const d: Date = new Date()
  const startingSun: Date | string = isSunday(d) ? d : previousSunday(d)
  const endingSat: Date | string = isSaturday(d) ? d : nextSaturday(d)

  const allUsersAvailability = useSelector((state: RootState) => state.allUsersAvailability)
  const areUsersAvailable = Object.keys(allUsersAvailability).length > 0 ? true : false
  const parsedInitialStartDate = parseISO(startdate)
  const parsedInitialEndDate = parseISO(enddate)

  const [updatedStartDate, setStartDate] = useState(parsedInitialStartDate)
  const [updatedEndDate, setEndDate] = useState(parsedInitialEndDate)

  useEffect(() => {
    dispatch(
      getAvailablePathologist({
        startdate: convertToFormattedString(updatedStartDate),
        enddate: convertToFormattedString(updatedEndDate),
      }),
    )
  }, [updatedStartDate, updatedEndDate])

  function handlePrevWeek() {
    setStartDate(previousSunday(updatedStartDate))
    setEndDate(previousSaturday(updatedEndDate))
  }

  function handleNextWeek() {
    setStartDate(nextSunday(updatedStartDate))
    setEndDate(nextSaturday(updatedEndDate))
  }

  const usersAvailabilityKeys: any = Object.keys(allUsersAvailability)

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'left', mt: '10px' }}>
        <p style={{ color: '#0a688d', fontWeight: 500 }}>Weekly pathologist availability</p>
      </Box>
      {areUsersAvailable ? (
        <Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
              mt: '10px',
            }}
          >
            <Box sx={{ display: 'flex', fontSize: '24px', alignItems: 'center' }}>
              <ArrowBackIos onClick={handlePrevWeek} className="WP_btn" />
              <Typography
                sx={{
                  fontSize: '24px',
                  fontWeight: 500,
                  color: '#0a688d',
                  width: '340px',
                  mx: '10px',
                  textAlign: 'center',
                }}
              >{` ${format(updatedStartDate, 'MMMM dd')} - ${format(updatedEndDate, 'MMMM dd')} `}</Typography>
              <ArrowForwardIos onClick={handleNextWeek} className="WP_btn" />
            </Box>
          </Box>
          <Box className="week">
            <Box className="daysContainer">
              {usersAvailabilityKeys.map((calKey, i) => (
                <DailyAvailability
                  key={i}
                  date={calKey}
                  doctors={allUsersAvailability[calKey]}
                  handleChange={handleChange}
                />
              ))}
            </Box>
          </Box>
        </Box>
      ) : (
        <Box>
          <Typography
            color="disabled"
            sx={{ fontSize: '20px', fontWeight: 500, m: '152px 0px 63px 650px', color: 'lightgrey' }}
            variant="h2"
          >
            <CircularProgress />
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default WeeklyCalendar
